module.exports = __webpack_public_path__ + "img/inquiry_banner.6bd1809.png";